<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7937_14697)">
      <path d="M6.03125 5.77734L25.9688 5.77734V26.2764H6.03125V5.77734Z"
            fill="url(#paint0_linear_7937_14697)"
      />
      <path d="M6.03125 5.77734L25.9688 5.77734V26.2764H6.03125V5.77734Z"
            fill="url(#paint1_linear_7937_14697)"
      />
      <path d="M6.03125 5.77734L25.9688 5.77734V26.2764H6.03125V5.77734Z"
            fill="url(#paint2_linear_7937_14697)"
            fill-opacity="0.7"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="#FF9544"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="url(#paint3_linear_7937_14697)"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="url(#paint4_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="url(#paint5_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="url(#paint6_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M12.5156 9.07998C12.5156 8.74861 12.247 8.47998 11.9156 8.47998H9.80312C9.47175 8.47998 9.20312 8.74861 9.20312 9.07998V11.1925C9.20312 11.5239 9.47175 11.7925 9.80312 11.7925H11.9156C12.247 11.7925 12.5156 11.5239 12.5156 11.1925V9.07998Z"
            fill="url(#paint7_linear_7937_14697)"
      />
      <path d="M17.6562 9.07998C17.6562 8.74861 17.3876 8.47998 17.0562 8.47998H14.9437C14.6124 8.47998 14.3438 8.74861 14.3438 9.07998V11.1925C14.3438 11.5239 14.6124 11.7925 14.9437 11.7925H17.0563C17.3876 11.7925 17.6562 11.5239 17.6562 11.1925V9.07998Z"
            fill="#38C6FF"
      />
      <path d="M17.6562 9.07998C17.6562 8.74861 17.3876 8.47998 17.0562 8.47998H14.9437C14.6124 8.47998 14.3438 8.74861 14.3438 9.07998V11.1925C14.3438 11.5239 14.6124 11.7925 14.9437 11.7925H17.0563C17.3876 11.7925 17.6562 11.5239 17.6562 11.1925V9.07998Z"
            fill="url(#paint8_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M17.6562 9.07998C17.6562 8.74861 17.3876 8.47998 17.0562 8.47998H14.9437C14.6124 8.47998 14.3438 8.74861 14.3438 9.07998V11.1925C14.3438 11.5239 14.6124 11.7925 14.9437 11.7925H17.0563C17.3876 11.7925 17.6562 11.5239 17.6562 11.1925V9.07998Z"
            fill="url(#paint9_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M17.6562 9.07998C17.6562 8.74861 17.3876 8.47998 17.0562 8.47998H14.9437C14.6124 8.47998 14.3438 8.74861 14.3438 9.07998V11.1925C14.3438 11.5239 14.6124 11.7925 14.9437 11.7925H17.0563C17.3876 11.7925 17.6562 11.5239 17.6562 11.1925V9.07998Z"
            fill="url(#paint10_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M17.6562 9.07998C17.6562 8.74861 17.3876 8.47998 17.0562 8.47998H14.9437C14.6124 8.47998 14.3438 8.74861 14.3438 9.07998V11.1925C14.3438 11.5239 14.6124 11.7925 14.9437 11.7925H17.0563C17.3876 11.7925 17.6562 11.5239 17.6562 11.1925V9.07998Z"
            fill="url(#paint11_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M22.7969 9.07998C22.7969 8.74861 22.5282 8.47998 22.1969 8.47998H20.0844C19.753 8.47998 19.4844 8.74861 19.4844 9.07998V11.1925C19.4844 11.5239 19.753 11.7925 20.0844 11.7925H22.1969C22.5282 11.7925 22.7969 11.5239 22.7969 11.1925V9.07998Z"
            fill="#FFEC58"
      />
      <path d="M22.7969 9.07998C22.7969 8.74861 22.5282 8.47998 22.1969 8.47998H20.0844C19.753 8.47998 19.4844 8.74861 19.4844 9.07998V11.1925C19.4844 11.5239 19.753 11.7925 20.0844 11.7925H22.1969C22.5282 11.7925 22.7969 11.5239 22.7969 11.1925V9.07998Z"
            fill="url(#paint12_linear_7937_14697)"
            fill-opacity="0.5"
      />
      <path d="M22.7969 9.07998C22.7969 8.74861 22.5282 8.47998 22.1969 8.47998H20.0844C19.753 8.47998 19.4844 8.74861 19.4844 9.07998V11.1925C19.4844 11.5239 19.753 11.7925 20.0844 11.7925H22.1969C22.5282 11.7925 22.7969 11.5239 22.7969 11.1925V9.07998Z"
            fill="url(#paint13_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M22.7969 9.07998C22.7969 8.74861 22.5282 8.47998 22.1969 8.47998H20.0844C19.753 8.47998 19.4844 8.74861 19.4844 9.07998V11.1925C19.4844 11.5239 19.753 11.7925 20.0844 11.7925H22.1969C22.5282 11.7925 22.7969 11.5239 22.7969 11.1925V9.07998Z"
            fill="url(#paint14_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M22.7969 9.07998C22.7969 8.74861 22.5282 8.47998 22.1969 8.47998H20.0844C19.753 8.47998 19.4844 8.74861 19.4844 9.07998V11.1925C19.4844 11.5239 19.753 11.7925 20.0844 11.7925H22.1969C22.5282 11.7925 22.7969 11.5239 22.7969 11.1925V9.07998Z"
            fill="url(#paint15_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z"
            fill="#38C6FF"
      />
      <path d="M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z"
            fill="url(#paint16_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z"
            fill="url(#paint17_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z"
            fill="url(#paint18_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M9.20312 14.9394C9.20312 14.608 9.47175 14.3394 9.80313 14.3394H11.9156C12.247 14.3394 12.5156 14.608 12.5156 14.9394V17.0519C12.5156 17.3832 12.247 17.6519 11.9156 17.6519H9.80312C9.47175 17.6519 9.20312 17.3832 9.20312 17.0519V14.9394Z"
            fill="url(#paint19_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="#FF9544"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="url(#paint20_linear_7937_14697)"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="url(#paint21_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="url(#paint22_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="url(#paint23_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M9.20312 20.7987C9.20312 20.4674 9.47175 20.1987 9.80313 20.1987H11.9156C12.247 20.1987 12.5156 20.4674 12.5156 20.7987V22.9112C12.5156 23.2426 12.247 23.5112 11.9156 23.5112H9.80312C9.47175 23.5112 9.20312 23.2426 9.20312 22.9112V20.7987Z"
            fill="url(#paint24_linear_7937_14697)"
      />
      <path d="M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z"
            fill="#FFEC58"
      />
      <path d="M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z"
            fill="url(#paint25_linear_7937_14697)"
            fill-opacity="0.5"
      />
      <path d="M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z"
            fill="url(#paint26_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z"
            fill="url(#paint27_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 14.9394C14.3438 14.608 14.6124 14.3394 14.9438 14.3394H17.0563C17.3876 14.3394 17.6562 14.608 17.6562 14.9394V17.0519C17.6562 17.3832 17.3876 17.6519 17.0563 17.6519H14.9437C14.6124 17.6519 14.3438 17.3832 14.3438 17.0519V14.9394Z"
            fill="url(#paint28_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z"
            fill="#38C6FF"
      />
      <path d="M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z"
            fill="url(#paint29_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z"
            fill="url(#paint30_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z"
            fill="url(#paint31_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M14.3438 20.7987C14.3438 20.4674 14.6124 20.1987 14.9438 20.1987H17.0563C17.3876 20.1987 17.6562 20.4674 17.6562 20.7987V22.9112C17.6562 23.2426 17.3876 23.5112 17.0563 23.5112H14.9437C14.6124 23.5112 14.3438 23.2426 14.3438 22.9112V20.7987Z"
            fill="url(#paint32_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="#FF9544"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="url(#paint33_linear_7937_14697)"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="url(#paint34_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="url(#paint35_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="url(#paint36_linear_7937_14697)"
            fill-opacity="0.8"
      />
      <path d="M19.4844 14.9394C19.4844 14.608 19.753 14.3394 20.0844 14.3394H22.1969C22.5282 14.3394 22.7969 14.608 22.7969 14.9394V17.0519C22.7969 17.3832 22.5282 17.6519 22.1969 17.6519H20.0844C19.753 17.6519 19.4844 17.3832 19.4844 17.0519V14.9394Z"
            fill="url(#paint37_linear_7937_14697)"
      />
      <path d="M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z"
            fill="#FFEC58"
      />
      <path d="M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z"
            fill="url(#paint38_linear_7937_14697)"
            fill-opacity="0.5"
      />
      <path d="M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z"
            fill="url(#paint39_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z"
            fill="url(#paint40_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M19.4844 20.7987C19.4844 20.4674 19.753 20.1987 20.0844 20.1987H22.1969C22.5282 20.1987 22.7969 20.4674 22.7969 20.7987V22.9112C22.7969 23.2426 22.5282 23.5112 22.1969 23.5112H20.0844C19.753 23.5112 19.4844 23.2426 19.4844 22.9112V20.7987Z"
            fill="url(#paint41_linear_7937_14697)"
            fill-opacity="0.6"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint42_linear_7937_14697)"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint43_linear_7937_14697)"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint44_linear_7937_14697)"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint45_linear_7937_14697)"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint46_radial_7937_14697)"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint47_linear_7937_14697)"
            fill-opacity="0.5"
      />
      <path d="M25.9688 6.15967H6.03125V4.63467C6.03125 3.19873 7.19531 2.03467 8.63125 2.03467H23.3688C24.8047 2.03467 25.9688 3.19873 25.9688 4.63467V6.15967Z"
            fill="url(#paint48_linear_7937_14697)"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint49_linear_7937_14697)"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint50_linear_7937_14697)"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint51_radial_7937_14697)"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint52_linear_7937_14697)"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint53_linear_7937_14697)"
            fill-opacity="0.5"
      />
      <path d="M25.9688 25.8784V27.3565C25.9688 28.7925 24.8047 29.9565 23.3688 29.9565H8.63125C7.19531 29.9565 6.03125 28.7925 6.03125 27.3565V25.8784H25.9688Z"
            fill="url(#paint54_linear_7937_14697)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7937_14697"
                      x1="16"
                      y1="7.44104"
                      x2="16"
                      y2="26.0035"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#62326D" />
        <stop offset="1"
              stop-color="#434486"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7937_14697"
                      x1="6.03125"
                      y1="21.816"
                      x2="8.34375"
                      y2="21.8785"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.03125"
              stop-color="#412C4C"
        />
        <stop offset="1"
              stop-color="#412C4C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7937_14697"
                      x1="27.4688"
                      y1="21.8785"
                      x2="22.5438"
                      y2="21.8831"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.250342"
              stop-color="#232222"
              stop-opacity="0.13"
        />
        <stop offset="0.589857"
              stop-color="#FFFFFF"
              stop-opacity="0.13"
        />
        <stop offset="0.772724"
              stop-color="#FFFFFF"
              stop-opacity="0.06"
        />
        <stop offset="1"
              stop-color="#503F7E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7937_14697"
                      x1="12.3594"
                      y1="10.9565"
                      x2="11.3125"
                      y2="10.9565"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.333333"
              stop-color="#FF945C"
        />
        <stop offset="1"
              stop-color="#FF945C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_7937_14697"
                      x1="8.60685"
                      y1="10.0233"
                      x2="12.9874"
                      y2="9.98724"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.115577"
              stop-color="#E05A19"
        />
        <stop offset="0.212961"
              stop-color="#EC6926"
              stop-opacity="0.35"
        />
        <stop offset="0.282884"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.668969"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0.37"
        />
        <stop offset="0.810742"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.874984"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7937_14697"
                      x1="8.29885"
                      y1="8.23836"
                      x2="13.102"
                      y2="12.451"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7937_14697"
                      x1="8.29885"
                      y1="8.23836"
                      x2="13.102"
                      y2="12.451"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint7_linear_7937_14697"
                      x1="10.8594"
                      y1="7.74389"
                      x2="10.8594"
                      y2="12.2172"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0737136"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.3403"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint8_linear_7937_14697"
                      x1="16"
                      y1="7.74389"
                      x2="16"
                      y2="12.4557"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#1B94DF"
        />
        <stop offset="0.183189"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.266068"
              stop-color="#1B95DF"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#056EAD"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint9_linear_7937_14697"
                      x1="13.643"
                      y1="10.1362"
                      x2="18.4242"
                      y2="10.1362"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119886"
              stop-color="#056EAD"
        />
        <stop offset="0.183515"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.319761"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.617817"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.685957"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.797458"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint10_linear_7937_14697"
                      x1="14.0369"
                      y1="7.87561"
                      x2="18.1258"
                      y2="12.2355"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_7937_14697"
                      x1="14.0369"
                      y1="7.87561"
                      x2="18.1258"
                      y2="12.2355"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7937_14697"
                      x1="21.1406"
                      y1="7.74389"
                      x2="21.1406"
                      y2="12.4557"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.155632"
              stop-color="#CFB217"
        />
        <stop offset="0.203512"
              stop-color="#CFB217"
              stop-opacity="0.36"
        />
        <stop offset="0.279655"
              stop-color="#FFEC58"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint13_linear_7937_14697"
                      x1="18.567"
                      y1="7.68769"
                      x2="23.8738"
                      y2="12.5634"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint14_linear_7937_14697"
                      x1="18.567"
                      y1="7.68769"
                      x2="23.6872"
                      y2="12.3455"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_7937_14697"
                      x1="18.923"
                      y1="9.9482"
                      x2="23.5857"
                      y2="9.9482"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0412901"
              stop-color="#CFB217"
        />
        <stop offset="0.165564"
              stop-color="#CFB217"
              stop-opacity="0.52"
        />
        <stop offset="0.260484"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.733076"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint16_linear_7937_14697"
                      x1="10.8594"
                      y1="13.6033"
                      x2="10.8594"
                      y2="18.3151"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#1B94DF"
        />
        <stop offset="0.183189"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.266068"
              stop-color="#1B95DF"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#056EAD"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_7937_14697"
                      x1="13.2164"
                      y1="15.9956"
                      x2="8.4352"
                      y2="15.9956"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119886"
              stop-color="#056EAD"
        />
        <stop offset="0.183515"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.319761"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.617817"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.685957"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.797458"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7937_14697"
                      x1="12.8225"
                      y1="13.735"
                      x2="8.73362"
                      y2="18.0949"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7937_14697"
                      x1="12.8225"
                      y1="13.735"
                      x2="8.73362"
                      y2="18.0949"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7937_14697"
                      x1="9.35937"
                      y1="22.6753"
                      x2="10.4062"
                      y2="22.6753"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.333333"
              stop-color="#FF945C"
        />
        <stop offset="1"
              stop-color="#FF945C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_7937_14697"
                      x1="13.1119"
                      y1="21.742"
                      x2="8.73131"
                      y2="21.706"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.115577"
              stop-color="#E05A19"
        />
        <stop offset="0.212961"
              stop-color="#EC6926"
              stop-opacity="0.35"
        />
        <stop offset="0.282884"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.668969"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0.37"
        />
        <stop offset="0.810742"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.874984"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_7937_14697"
                      x1="13.4199"
                      y1="19.9571"
                      x2="8.61674"
                      y2="24.1697"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7937_14697"
                      x1="13.4199"
                      y1="19.9571"
                      x2="8.61674"
                      y2="24.1697"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7937_14697"
                      x1="10.8594"
                      y1="19.4626"
                      x2="10.8594"
                      y2="23.9359"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0737136"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.3403"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7937_14697"
                      x1="16"
                      y1="13.6033"
                      x2="16"
                      y2="18.3151"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.155632"
              stop-color="#CFB217"
        />
        <stop offset="0.203512"
              stop-color="#CFB217"
              stop-opacity="0.36"
        />
        <stop offset="0.279655"
              stop-color="#FFEC58"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7937_14697"
                      x1="18.5736"
                      y1="13.5471"
                      x2="13.2669"
                      y2="18.4227"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7937_14697"
                      x1="18.5736"
                      y1="13.5471"
                      x2="13.4534"
                      y2="18.2049"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint28_linear_7937_14697"
                      x1="18.2176"
                      y1="15.8076"
                      x2="13.5549"
                      y2="15.8076"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0412901"
              stop-color="#CFB217"
        />
        <stop offset="0.165564"
              stop-color="#CFB217"
              stop-opacity="0.52"
        />
        <stop offset="0.260484"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.733076"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_7937_14697"
                      x1="16"
                      y1="19.4626"
                      x2="16"
                      y2="24.1745"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#1B94DF"
        />
        <stop offset="0.183189"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.266068"
              stop-color="#1B95DF"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#056EAD"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7937_14697"
                      x1="18.357"
                      y1="21.855"
                      x2="13.5758"
                      y2="21.855"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119886"
              stop-color="#056EAD"
        />
        <stop offset="0.183515"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.319761"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.617817"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.685957"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.797458"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#056EAD"
        />
      </linearGradient>
      <linearGradient id="paint31_linear_7937_14697"
                      x1="17.9631"
                      y1="19.5944"
                      x2="13.8742"
                      y2="23.9543"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint32_linear_7937_14697"
                      x1="17.9631"
                      y1="19.5944"
                      x2="13.8742"
                      y2="23.9543"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.133992"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
        <stop offset="0.220366"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.353268"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.689154"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.798359"
              stop-color="#31BAF3"
              stop-opacity="0"
        />
        <stop offset="0.899472"
              stop-color="#056EAD"
              stop-opacity="0.56"
        />
      </linearGradient>
      <linearGradient id="paint33_linear_7937_14697"
                      x1="19.6406"
                      y1="16.8159"
                      x2="20.6875"
                      y2="16.8159"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.333333"
              stop-color="#FF945C"
        />
        <stop offset="1"
              stop-color="#FF945C"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint34_linear_7937_14697"
                      x1="23.3931"
                      y1="15.8827"
                      x2="19.0126"
                      y2="15.8466"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.115577"
              stop-color="#E05A19"
        />
        <stop offset="0.212961"
              stop-color="#EC6926"
              stop-opacity="0.35"
        />
        <stop offset="0.282884"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.668969"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0.37"
        />
        <stop offset="0.810742"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.874984"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint35_linear_7937_14697"
                      x1="23.7012"
                      y1="14.0977"
                      x2="18.898"
                      y2="18.3103"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_7937_14697"
                      x1="23.7012"
                      y1="14.0977"
                      x2="18.898"
                      y2="18.3103"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.327346"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.698376"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.835105"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint37_linear_7937_14697"
                      x1="21.1406"
                      y1="13.6033"
                      x2="21.1406"
                      y2="18.0766"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0737136"
              stop-color="#EC6926"
        />
        <stop offset="0.183189"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.3403"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.74008"
              stop-color="#FF9544"
              stop-opacity="0"
        />
        <stop offset="0.843047"
              stop-color="#EC6926"
              stop-opacity="0.56"
        />
        <stop offset="0.89849"
              stop-color="#EC6926"
        />
      </linearGradient>
      <linearGradient id="paint38_linear_7937_14697"
                      x1="21.1406"
                      y1="19.4626"
                      x2="21.1406"
                      y2="24.1745"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.155632"
              stop-color="#CFB217"
        />
        <stop offset="0.203512"
              stop-color="#CFB217"
              stop-opacity="0.36"
        />
        <stop offset="0.279655"
              stop-color="#FFEC58"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint39_linear_7937_14697"
                      x1="23.7142"
                      y1="19.4064"
                      x2="18.4075"
                      y2="24.2821"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint40_linear_7937_14697"
                      x1="23.7142"
                      y1="19.4064"
                      x2="18.594"
                      y2="24.0643"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.143541"
              stop-color="#CFB217"
        />
        <stop offset="0.183189"
              stop-color="#CFB217"
              stop-opacity="0.83"
        />
        <stop offset="0.279655"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.69452"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint41_linear_7937_14697"
                      x1="23.3583"
                      y1="21.6669"
                      x2="18.6955"
                      y2="21.6669"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0412901"
              stop-color="#CFB217"
        />
        <stop offset="0.165564"
              stop-color="#CFB217"
              stop-opacity="0.52"
        />
        <stop offset="0.260484"
              stop-color="#CFB217"
              stop-opacity="0"
        />
        <stop offset="0.733076"
              stop-color="#DFC434"
              stop-opacity="0"
        />
        <stop offset="0.801815"
              stop-color="#CFB217"
              stop-opacity="0.75"
        />
        <stop offset="0.863376"
              stop-color="#CFB217"
        />
      </linearGradient>
      <linearGradient id="paint42_linear_7937_14697"
                      x1="16"
                      y1="2.03467"
                      x2="16"
                      y2="6.15967"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#636AB6" />
        <stop offset="1"
              stop-color="#6C6EBE"
        />
      </linearGradient>
      <linearGradient id="paint43_linear_7937_14697"
                      x1="17.1563"
                      y1="6.31592"
                      x2="17.1563"
                      y2="5.62842"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6062B1" />
        <stop offset="1"
              stop-color="#6062B1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint44_linear_7937_14697"
                      x1="6.03125"
                      y1="6.15967"
                      x2="9.25"
                      y2="6.15967"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135922"
              stop-color="#484B86"
        />
        <stop offset="1"
              stop-color="#5E61AD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint45_linear_7937_14697"
                      x1="25.9688"
                      y1="6.15967"
                      x2="23.0312"
                      y2="6.15967"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.12766"
              stop-color="#7277C8"
        />
        <stop offset="1"
              stop-color="#7277C8"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint46_radial_7937_14697"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.9688 5.87842) rotate(-180) scale(0.65625 3.17187)"
      >
        <stop stop-color="#6C6FB4" />
        <stop offset="1"
              stop-color="#6C6FB4"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint47_linear_7937_14697"
                      x1="27.4688"
                      y1="4.96626"
                      x2="22.544"
                      y2="4.99693"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.250342"
              stop-color="#232222"
              stop-opacity="0.13"
        />
        <stop offset="0.589857"
              stop-color="#FFFFFF"
              stop-opacity="0.13"
        />
        <stop offset="0.772724"
              stop-color="#FFFFFF"
              stop-opacity="0.06"
        />
        <stop offset="1"
              stop-color="#503F7E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint48_linear_7937_14697"
                      x1="25.9687"
                      y1="0.819559"
                      x2="23.4262"
                      y2="4.09717"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135922"
              stop-color="#484B86"
        />
        <stop offset="1"
              stop-color="#5E61AD"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint49_linear_7937_14697"
                      x1="16"
                      y1="25.8784"
                      x2="16"
                      y2="29.9565"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6B4390" />
        <stop offset="1"
              stop-color="#76509E"
        />
      </linearGradient>
      <linearGradient id="paint50_linear_7937_14697"
                      x1="6.03125"
                      y1="27.1284"
                      x2="8.4375"
                      y2="27.1284"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.164179"
              stop-color="#4F3D6C"
        />
        <stop offset="1"
              stop-color="#6E4693"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint51_radial_7937_14697"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.3125 25.5347) rotate(90) scale(3.09375 1.625)"
      >
        <stop stop-color="#6B5094" />
        <stop offset="1"
              stop-color="#6B5094"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint52_linear_7937_14697"
                      x1="15.6875"
                      y1="25.5972"
                      x2="15.6875"
                      y2="26.1909"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.157895"
              stop-color="#5E3D7F"
        />
        <stop offset="1"
              stop-color="#5E3D7F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint53_linear_7937_14697"
                      x1="27.4688"
                      y1="28.7767"
                      x2="22.544"
                      y2="28.8077"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.250342"
              stop-color="#232222"
              stop-opacity="0.13"
        />
        <stop offset="0.589857"
              stop-color="#FFFFFF"
              stop-opacity="0.13"
        />
        <stop offset="0.772724"
              stop-color="#FFFFFF"
              stop-opacity="0.06"
        />
        <stop offset="1"
              stop-color="#503F7E"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint54_linear_7937_14697"
                      x1="26.2285"
                      y1="30.9535"
                      x2="22.7027"
                      y2="27.4855"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.195124"
              stop-color="#5E3D7F"
        />
        <stop offset="0.629149"
              stop-color="#5E3D7F"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7937_14697">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
